import { StateService, StateParams } from "@uirouter/angularjs";

export class CmdCenterNetworkCmdCtrl {
    public static $inject = ['$scope','$location','$state','$stateParams'];
    constructor($scope:any, $location: ng.ILocationService, stateService:StateService,
                stateParamsService:StateParams) {
        $scope.vm = this;
    }
    CMDSHUTDOWN="Shutdown";
    CMDRESUME="Resume";
    CMDSETSECURITY="Set Security";
    CMDRESETNETWORK = "Reset Network";
    CMDSETREPORTINGINTERVAL = "Set Reporting Interval";
    commands:string[] = [this.CMDSETSECURITY,this.CMDRESETNETWORK,
        this.CMDSETREPORTINGINTERVAL];
    selectedCommand = this.CMDSETREPORTINGINTERVAL;
}
